import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Booking Button
const BookingButton = ({ booking }) => {
	const handleBookingClick = () => {
		if (typeof window !== 'undefined' && window.gtag) {
			window.gtag('event', 'conversion', {
				send_to: 'AW-11422420127/qm3WCIzs5v4BEJS6rM4B'
			});
		}
	};
	return (
		<a
			rel='external nofollow noopener'
			target='_blank'
			className='nav-link port-navbar-link active open_booking-iframe-navbutton clickable'
			onClick={handleBookingClick}
		>
			<FontAwesomeIcon icon={['fas', 'calendar-check']} />
			&nbsp;{booking}
		</a>
	);
};

export default BookingButton;
